"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anchorProviderToSerumProvider = exports.providerToAnchorProvider = void 0;
// Keep this to only general utils
var anchor_1 = require("@project-serum/anchor");
var common_1 = require("@project-serum/common");
/**
 * There are lots of different Provider derivatives. FriktionSDK shouldn't
 * require usage of Solana provider.
 *
 * However, we use Anchor's Provider as ReadonlyProvider because it is
 * incompatible with TransactionEnvelope.
 */
var providerToAnchorProvider = function (provider) {
    return new anchor_1.AnchorProvider(provider.connection, provider.wallet, {
        commitment: "confirmed",
    });
};
exports.providerToAnchorProvider = providerToAnchorProvider;
var anchorProviderToSerumProvider = function (provider) {
    return new common_1.Provider(provider.connection, provider.wallet, provider.opts);
};
exports.anchorProviderToSerumProvider = anchorProviderToSerumProvider;
